import { PsCompany as PsCompanyBase } from '../../shared/model/company/PsCompany';

export class PsCompany extends PsCompanyBase {}



// WEBPACK FOOTER //
// ./src/app/my-company/company/PsCompany.js